const state = {
    list: [
        {
            label: 'Кассовый',
            value: 0,
            PaymentTypeId: 6,
        },
        {
            label: 'Безналичный',
            value: 1,
            PaymentTypeId: 2,
        },
        {
            label: 'Бонусный',
            value: 2,
            PaymentTypeId: 7,
        },
    ],
    load: false,
};
const mutations = {
};
const actions = {
};
const getters = {
    getById: (state, getters) => id => {
        if (!state.list.length) return null;
        return state.list.filter(i => {
            return i.value === id;
        })[0] || {};
    },
};


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}